import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { BASE_DEV_URL } from "../../config/api.config";
import { ID_TOKEN } from "../../config/app.config";

export const fetchConversionRate = createAsyncThunk(
  "casinoConversion/fetchConversionRate",
  async (_, { getState, rejectWithValue }) => {
    try {
      const token =
        getState().auth?.token ||
        getState().authData?.token ||
        localStorage.getItem(ID_TOKEN);

      if (!token) return rejectWithValue("User not authenticated");

      const response = await fetch(`${BASE_DEV_URL}getCasinoConversionRate`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      if (!response.ok) throw new Error("Failed to fetch conversion rate");

      const data = await response.json();
      return data?.data?.casino_conversion_rate;
    } catch (err) {
      return rejectWithValue(err.message);
    }
  },
);

const casinoConversionSlice = createSlice({
  name: "casinoConversion",
  initialState: {
    rate: null,
    loading: false,
    error: null,
    open: false,
    pendingNavigation: null,
  },
  reducers: {
    openModal: (state, action) => {
      state.open = true;
      state.pendingNavigation = action.payload; // { path }
    },
    closeModal: (state) => {
      state.open = false;
      state.pendingNavigation = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchConversionRate.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchConversionRate.fulfilled, (state, action) => {
        state.loading = false;
        state.rate = action.payload;
      })
      .addCase(fetchConversionRate.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { openModal, closeModal } = casinoConversionSlice.actions;

export default casinoConversionSlice.reducer;
